import React from 'react';

const IndicatorConfirmed: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill="#6FABA1" fillRule="nonzero">
        <g>
          <g>
            <path d="M13.945 22.998l1.628-1.617c.169-.158.316-.222.538-.222h2.283c1.89 0 2.768-.866 2.768-2.767V16.11c0-.222.063-.37.222-.54l1.606-1.626c1.352-1.331 1.341-2.567 0-3.898l-1.606-1.627c-.159-.159-.222-.317-.222-.529V5.598c0-1.88-.867-2.768-2.768-2.768H16.11c-.222 0-.37-.053-.538-.211l-1.628-1.617c-1.33-1.341-2.567-1.33-3.898 0L8.42 2.62c-.159.158-.317.211-.529.211H5.6c-1.892 0-2.769.866-2.769 2.768V7.89c0 .212-.053.37-.211.529l-1.617 1.627c-1.341 1.33-1.33 2.567 0 3.898L2.62 15.57c.158.169.211.317.211.539v2.282c0 1.89.877 2.767 2.769 2.767H7.89c.212 0 .37.064.529.222l1.627 1.617c1.33 1.341 2.567 1.33 3.898 0zm-3.73-5.684c-.327 0-.538-.106-.697-.285l-3.529-3.92c-.147-.169-.232-.38-.232-.602 0-.496.38-.866.92-.866.284 0 .496.095.686.296l2.8 3.095 5.441-7.66c.212-.306.423-.432.793-.432.517 0 .887.38.887.876 0 .18-.074.391-.19.56l-6.16 8.61c-.158.201-.401.328-.718.328z" transform="translate(-36 -250) translate(16 226) translate(20 24)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IndicatorConfirmed;
